export const GoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z"
        fill="#00304A"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.781 5.96508C14.2088 5.58714 13.9713 4.87419 13.405 4.83539L9.57539 4.57303C9.32842 4.5561 9.1137 4.39587 9.02403 4.16211L7.59176 0.412331C7.38176 -0.137528 6.61332 -0.137528 6.40331 0.412323L4.97105 4.16214C4.88217 4.39589 4.66666 4.55611 4.41969 4.57305L0.595111 4.83539C0.0289665 4.87422 -0.208332 5.58669 0.21899 5.96479L3.18932 8.59304C3.36896 8.752 3.44581 8.99929 3.38855 9.23384L2.41946 13.1976C2.28056 13.7658 2.90066 14.2126 3.38524 13.8934L6.65028 11.7427C6.86186 11.6036 7.134 11.6036 7.34479 11.7427L10.6097 13.8934C11.095 14.2126 11.7147 13.7658 11.5755 13.1976L10.6065 9.23416C10.5499 8.99945 10.6262 8.752 10.8063 8.59304L13.781 5.96508Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg
      width="50"
      height="15"
      viewBox="0 0 50 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.5C0.447715 6.5 0 6.94772 0 7.5C0 8.05228 0.447715 8.5 1 8.5V6.5ZM49.7071 8.20711C50.0976 7.81658 50.0976 7.18342 49.7071 6.79289L43.3431 0.428932C42.9526 0.0384078 42.3195 0.0384078 41.9289 0.428932C41.5384 0.819457 41.5384 1.45262 41.9289 1.84315L47.5858 7.5L41.9289 13.1569C41.5384 13.5474 41.5384 14.1805 41.9289 14.5711C42.3195 14.9616 42.9526 14.9616 43.3431 14.5711L49.7071 8.20711ZM1 8.5H49V6.5H1V8.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      width="49"
      height="50"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6423 34.0129L36.0361 19.6192L33.1777 16.7608L21.6423 28.2963L15.8236 22.4775L12.9652 25.3358L21.6423 34.0129ZM24.5007 45.0379C21.6763 45.0379 19.0222 44.502 16.5382 43.4301C14.0541 42.3582 11.8934 40.9035 10.0559 39.066C8.21836 37.2285 6.76367 35.0678 5.6918 32.5838C4.61992 30.0997 4.08398 27.4456 4.08398 24.6213C4.08398 21.797 4.61992 19.1428 5.6918 16.6588C6.76367 14.1747 8.21836 12.014 10.0559 10.1765C11.8934 8.33896 14.0541 6.88428 16.5382 5.8124C19.0222 4.74053 21.6763 4.20459 24.5007 4.20459C27.325 4.20459 29.9791 4.74053 32.4632 5.8124C34.9472 6.88428 37.1079 8.33896 38.9454 10.1765C40.7829 12.014 42.2376 14.1747 43.3095 16.6588C44.3814 19.1428 44.9173 21.797 44.9173 24.6213C44.9173 27.4456 44.3814 30.0997 43.3095 32.5838C42.2376 35.0678 40.7829 37.2285 38.9454 39.066C37.1079 40.9035 34.9472 42.3582 32.4632 43.4301C29.9791 44.502 27.325 45.0379 24.5007 45.0379ZM24.5007 40.9546C29.0604 40.9546 32.9225 39.3723 36.0871 36.2077C39.2517 33.0431 40.834 29.181 40.834 24.6213C40.834 20.0615 39.2517 16.1994 36.0871 13.0348C32.9225 9.87021 29.0604 8.28792 24.5007 8.28792C19.9409 8.28792 16.0788 9.87021 12.9142 13.0348C9.74961 16.1994 8.16732 20.0615 8.16732 24.6213C8.16732 29.181 9.74961 33.0431 12.9142 36.2077C16.0788 39.3723 19.9409 40.9546 24.5007 40.9546Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l14 0" />
      <path d="M5 12l6 6" />
      <path d="M5 12l6 -6" />
    </svg>
  );
};

export const HelpIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4625 12.5C7.725 12.5 7.94688 12.4094 8.12813 12.2281C8.30938 12.0469 8.4 11.825 8.4 11.5625C8.4 11.3 8.30938 11.0781 8.12813 10.8969C7.94688 10.7156 7.725 10.625 7.4625 10.625C7.2 10.625 6.97813 10.7156 6.79688 10.8969C6.61563 11.0781 6.525 11.3 6.525 11.5625C6.525 11.825 6.61563 12.0469 6.79688 12.2281C6.97813 12.4094 7.2 12.5 7.4625 12.5ZM6.7875 9.6125H8.175C8.175 9.2 8.22188 8.875 8.31563 8.6375C8.40938 8.4 8.675 8.075 9.1125 7.6625C9.4375 7.3375 9.69375 7.02813 9.88125 6.73438C10.0688 6.44063 10.1625 6.0875 10.1625 5.675C10.1625 4.975 9.90625 4.4375 9.39375 4.0625C8.88125 3.6875 8.275 3.5 7.575 3.5C6.8625 3.5 6.28438 3.6875 5.84063 4.0625C5.39688 4.4375 5.0875 4.8875 4.9125 5.4125L6.15 5.9C6.2125 5.675 6.35313 5.43125 6.57188 5.16875C6.79063 4.90625 7.125 4.775 7.575 4.775C7.975 4.775 8.275 4.88438 8.475 5.10313C8.675 5.32188 8.775 5.5625 8.775 5.825C8.775 6.075 8.7 6.30938 8.55 6.52813C8.4 6.74688 8.2125 6.95 7.9875 7.1375C7.4375 7.625 7.1 7.99375 6.975 8.24375C6.85 8.49375 6.7875 8.95 6.7875 9.6125ZM7.5 15.5C6.4625 15.5 5.4875 15.3031 4.575 14.9094C3.6625 14.5156 2.86875 13.9813 2.19375 13.3063C1.51875 12.6313 0.984375 11.8375 0.590625 10.925C0.196875 10.0125 0 9.0375 0 8C0 6.9625 0.196875 5.9875 0.590625 5.075C0.984375 4.1625 1.51875 3.36875 2.19375 2.69375C2.86875 2.01875 3.6625 1.48438 4.575 1.09063C5.4875 0.696875 6.4625 0.5 7.5 0.5C8.5375 0.5 9.5125 0.696875 10.425 1.09063C11.3375 1.48438 12.1313 2.01875 12.8063 2.69375C13.4813 3.36875 14.0156 4.1625 14.4094 5.075C14.8031 5.9875 15 6.9625 15 8C15 9.0375 14.8031 10.0125 14.4094 10.925C14.0156 11.8375 13.4813 12.6313 12.8063 13.3063C12.1313 13.9813 11.3375 14.5156 10.425 14.9094C9.5125 15.3031 8.5375 15.5 7.5 15.5ZM7.5 14C9.175 14 10.5938 13.4188 11.7563 12.2563C12.9188 11.0938 13.5 9.675 13.5 8C13.5 6.325 12.9188 4.90625 11.7563 3.74375C10.5938 2.58125 9.175 2 7.5 2C5.825 2 4.40625 2.58125 3.24375 3.74375C2.08125 4.90625 1.5 6.325 1.5 8C1.5 9.675 2.08125 11.0938 3.24375 12.2563C4.40625 13.4188 5.825 14 7.5 14Z"
        fill="currentColor"
      />
    </svg>
  );
};
